import { render, staticRenderFns } from "./TextInputGrow.vue?vue&type=template&id=06b4404a&lang=html"
import script from "./TextInputGrow.vue?vue&type=script&lang=js"
export * from "./TextInputGrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports